import { render, staticRenderFns } from "./TournamentEditHeartstonePick.vue?vue&type=template&id=72d5b158&scoped=true"
import script from "./TournamentEditHeartstonePick.vue?vue&type=script&lang=js"
export * from "./TournamentEditHeartstonePick.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditHeartstonePick.vue?vue&type=style&index=0&id=72d5b158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5b158",
  null
  
)

export default component.exports